import {
  DateOptionType,
  HeaderOptionType,
  JournalHeaderType,
  JournalType,
  LanguageType,
  SettingAreaPunchingType,
} from "@/enums/enums";
import { GetMerchantAddressModelDefault } from "@/helper/addressHelper";
import { GetCredential } from "@/helper/documentFacadeHelper";
import { GetJournalDocumentData } from "@/helper/JournalDocumentHelper";
import { GetJournalNameTypeModel } from "@/helper/shareHelper";
import { JournalDocumentDetailModel, JournalOnlineViewModel } from "@/model/document/journalDocumentModal";
import { SettingJournalDocumentTemplateModel } from "@/model/document/settingDocumentTemplate";

export function ConvertToDailyJournalOnlineView(detail: any): JournalOnlineViewModel {
  const onlineViewModel: JournalOnlineViewModel = new JournalOnlineViewModel();
  if (detail) {
    const documentDetailModel: JournalDocumentDetailModel = new JournalDocumentDetailModel();
    documentDetailModel.version = detail.document.version;
    documentDetailModel.data = GetJournalDocumentData(detail.document.data);
    onlineViewModel.document = documentDetailModel;
    onlineViewModel.transactionId = detail.transactionId;
    onlineViewModel.transactionType = detail.transactionType;
    onlineViewModel.financeType = detail.financeType;
    onlineViewModel.expenseType = detail.expenseType;
    onlineViewModel.template = detail.template
      ? detail.template.data
      : GetJournalSettingDocument(detail.headerOptionType);
    onlineViewModel.credential = GetCredential(detail.credential);
    onlineViewModel.headerOptionType = detail.headerOptionType;
  }

  return onlineViewModel;
}

export function GetJournalSettingDocument(headerOptionType: JournalHeaderType): SettingJournalDocumentTemplateModel {
  let settingTemplate = new SettingJournalDocumentTemplateModel();
  switch (headerOptionType) {
    case JournalHeaderType.MainJournalHeader: {
      settingTemplate = {
        colorCode: "#33355A",
        colorCodeCopy: "#33355A",
        language: LanguageType.Th,
        areaPunchingType: SettingAreaPunchingType.None,
        merchantLogo: {
          value: "",
          isShowElement: true,
        },
        headType: {
          copyAmount: 0,
          originalAmount: 1,
          headerTitleType: HeaderOptionType.Original,
          isShowDocumentSet: false,
          isShowHeaderOptionType: false,
        },
        documentNameType: {
          purchaseJournal: GetJournalNameTypeModel(JournalType.PurchaseJournal),
          salesJournal: GetJournalNameTypeModel(JournalType.SalesJournal),
          paymentJournal: GetJournalNameTypeModel(JournalType.PaymentJournal),
          receiveJournal: GetJournalNameTypeModel(JournalType.ReceiveJournal),
          generalJournal: GetJournalNameTypeModel(JournalType.GeneralJournal),
        },
        merchant: {
          isShowTextHeadOffice: true,
          merchantAddressTemplate: GetMerchantAddressModelDefault(),
          isCustomTextDisplay: false,
          merchantTitle: {
            value: "Organization_Title",
            isShowElement: true,
          },
          phoneNumber: {
            value: "",
            isShowElement: true,
          },
          email: {
            value: "",
            isShowElement: true,
          },
          website: {
            value: "",
            isShowElement: true,
          },
        },
        contact: {
          isShowContact: true,
          isCustomTextDisplay: false,
          isShowTextHeadOffice: true,
          contactTitle: {
            value: "Contact_Title",
            isShowElement: true,
          },
          isShowContactCode: true,
          dearTitle: {
            value: "Dear",
            isShowElement: true,
          },
          phoneNumber: {
            value: "",
            isShowElement: true,
          },
          email: {
            value: "",
            isShowElement: true,
          },
          website: {
            value: "",
            isShowElement: true,
          },
        },
        documentInfo: {
          documentNoTitle: {
            value: "Doc_No",
            isShowElement: true,
          },
          issedDateTitle: {
            value: "Issue_Date",
            isShowElement: true,
          },
          refTitle: {
            value: "Ref",
            isShowElement: true,
          },
          jonalTypeTitle: {
            value: "Journal_Title",
            isShowElement: true,
          },
          journalRefTaxDateTitle: {
            value: "Tax_Date_Title",
            isShowElement: true,
          },
          journalRefTaxNumberTitle: {
            value: "Tax_Invoice_Title",
            isShowElement: true,
          },
          dateOptionType: DateOptionType.DateADType1,
          isCustomTextDisplay: false,
        },
        certified: {
          userCreateTitle: {
            value: "Prepared_by_Title",
            isShowElement: true,
          },
          userApproveTitle: {
            value: "Approved_by_Title",
            isShowElement: true,
          },
          userReviewedTitle: {
            value: "Reviewed_by_Title",
            isShowElement: true,
          },
          isShowUserReviewedDate: true,
          isShowUserReviewedUrl: true,
          isShowUserCreateUrl: true,
          isShowUserApproveUrl: true,
          isShowUserCreateDate: true,
          isShowUserApproveDate: true,
          isShowUserCreateName: true,
          isShowUserApproveName: true,
          isCustomTextDisplay: false,
          isShowQRCode: true,
        },
      };
      break;
    }
  }

  return settingTemplate;
}
